module.exports = __webpack_public_path__ + "static/img/icon_classify_coffee.png";